export default "__VITE_ASSET__b3fde1ec__"